import * as types from '../constants/ActionTypes'
import { merge } from 'ramda';

/**
 * {
 *   101: {
 *     totalPages: 3,
 *     totalElements: 56,
 *     lastRequestedPage: 2,
 *   },
 *   102: {
 *     totalPages: 1,
 *     totalElements: 5,
 *     lastRequestedPage: 0,
 *   },
 *   102: {
 *     totalPages: 4,
 *     totalElements: 72,
 *     lastRequestedPage: 0,
 *   }
 * }
 */
const messagesPaging = (state = {}, action) => {
  switch (action.type) {
    case types.GET_MESSAGES_PAGING_DATA:
      return merge(state, action.payload);
    default:
      return state;
  }
};

export default messagesPaging;
